module.exports = __webpack_public_path__ + "img/组 130.0c594c04.png";